import React from 'react'
import { DatePicker, Space } from 'antd';
import dayjs from 'dayjs';
import FilterButton from './FilterButton';
const { RangePicker } = DatePicker;


const RangeDatePicker = () => {
    const onChange = (date) => {
        if (date) {
          console.log('Date: ', date);
        } else {
          console.log('Clear');
        }
      };
      const onRangeChange = (dates, dateStrings) => {
        if (dates) {
          console.log('From: ', dates[0], ', to: ', dates[1]);
          console.log('From: ', dateStrings[0], ', to: ', dateStrings[1]);
        } else {
          console.log('Clear');
        }
      };
      const rangePresets = [
        {
          label: 'Last 7 Days',
          value: [dayjs().add(-7, 'd'), dayjs()],
        },
        {
          label: 'Last 14 Days',
          value: [dayjs().add(-14, 'd'), dayjs()],
        },
        {
          label: 'Last 30 Days',
          value: [dayjs().add(-30, 'd'), dayjs()],
        },
        {
          label: 'Last 90 Days',
          value: [dayjs().add(-90, 'd'), dayjs()],
        },
      ];
  return (
    <div className='d-flex gap-2'>
      <Space direction="vertical" size={30}>
        
            <RangePicker presets={rangePresets} onChange={onRangeChange} style={{
            height:50
            }} />
           
        </Space>
        <FilterButton />
    </div>
  )
}

export default RangeDatePicker
